var isMobile = require('./isMobile.js').isMobile;

var AudioPlayer = function() {
  this.mode = '';
  this.currentTrack = '';
  this.player = null;
}

var SFX_TRACKS = [
  '/audio/yellocom_loop_v3.mp3',
];

var MUSIC_TRACKS = [
  '/audio/yello_point_medley.mp3',
  '/audio/yello_toy_medley.mp3',
  '/audio/yellowebmix_pt1.mp3',
  '/audio/yellowebmix_pt2.mp3',
  '/audio/yellowebmix_pt3.mp3',
];

var MUSIC_INDEX = MUSIC_TRACKS.length - 1;// Math.floor(Math.random() * MUSIC_TRACKS.length);

AudioPlayer.prototype.init = function() {
  this.setPlayMode('');
}

AudioPlayer.prototype.getPlayMode = function() {
  return this.mode;
}

AudioPlayer.prototype.setPlayMode = function(mode) {
  var track = null;

  if (mode == 'music') {
    MUSIC_INDEX ++;
    MUSIC_INDEX %= MUSIC_TRACKS.length;

    track = MUSIC_TRACKS[MUSIC_INDEX];
  }

  if (mode == 'sfx') {
    track = SFX_TRACKS[Math.floor(Math.random() * SFX_TRACKS.length)];
  }

  if (track != this.currentTrack) {
    // console.log('track url changed.');

    if (this.player) {
      // console.log('Stopping playback.');
      this.player.pause();
      delete this.player;
    }

    this.currentTrack = track;

    if (track) {
      // console.log('Starting to play: ' + track);
      if (typeof(Audio) !== 'undefined') {
        this.player = new Audio(track);
        this.player.play();
      }
    }
  }

  this.mode = mode;
}

module.exports = AudioPlayer;
